export const getSpeakerName = (forename, middleName, surname) =>
  [forename, middleName, surname].filter(Boolean).join(' ');
